<template>
  <div id="quoteTwo"></div>
</template>

<script>
export default {
  name: "QuoteTwo",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        quote:
          "Using LinkedIn without consistency is like *a ship without a compass*.",
        author: "John Doe",
        author_bio: "Author is a software engineer at Google",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler(newVal) {
        console.log("scale", newVal);
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    isDarkColor(color) {
      let r, g, b;

      // Handle hex color format (#ff0000 or #f00)
      if (color.startsWith("#")) {
        const hex = color.slice(1);
        // Handle 3-digit hex (#f00 -> #ff0000)
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          // Handle 6-digit hex (#ff0000)
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
      } else {
        // Handle RGB format (rgb(255, 0, 0))
        const rgb = color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return false;
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      }

      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128;
    },
    render() {
      const quoteTwo = document.getElementById("quoteTwo");
      if (!quoteTwo) return;
      quoteTwo.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const fontSize = exporting ? 64 : 64 * this.scale;
      const logoHeight = exporting ? 40 : 40 * this.scale;
      const authorSize = exporting ? 28 : 28 * this.scale;
      const bioSize = exporting ? 22 : 22 * this.scale;
      const chipSize = exporting ? 20 : 20 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.light || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#10a37f";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f0f 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Gradient orb effect -->
          <div style="
            position: absolute;
            top: -20%;
            right: -20%;
            width: 60%;
            height: 60%;
            background: radial-gradient(circle, ${primaryColor}25 0%, transparent 70%);
            pointer-events: none;
          "></div>
          <div style="
            position: absolute;
            bottom: -30%;
            left: -20%;
            width: 70%;
            height: 70%;
            background: radial-gradient(circle, #6366f130 0%, transparent 60%);
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img
              src="${logoSrc}"
              height="${logoHeight}px"
              alt=""
              style="opacity: 0.9;"
            />
          </div>

          <!-- Quote content -->
          <div style="padding: 0 8%; position: relative; z-index: 1; flex: 1; display: flex; flex-direction: column; justify-content: center;">
            <div style="
              font-size: ${fontSize}px;
              font-weight: 300;
              color: #ffffff;
              line-height: 1.3;
              letter-spacing: -0.02em;
              margin-bottom: 40px;
            ">"${this.data.quote.replace(
              /\*([^*]+)\*/g,
              `<span class="template-libre">$1</span>`,
            )}"</div>

            <div style="display: flex; align-items: center; gap: 16px;">
              <div style="
                width: 4px;
                height: 48px;
                background: linear-gradient(180deg, ${primaryColor} 0%, #6366f1 100%);
                border-radius: 2px;
              "></div>
              <div>
                <p style="color: #ffffff; font-size: ${authorSize}px; margin: 0; font-weight: 600; letter-spacing: 0.01em;">
                  ${this.data.author}
                </p>
                <p style="color: rgba(255, 255, 255, 0.6); font-size: ${bioSize}px; margin: 4px 0 0 0; font-weight: 400;">
                  ${this.data.author_bio}
                </p>
              </div>
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: rgba(255, 255, 255, 0.1);
                  backdrop-filter: blur(10px);
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 10px 24px;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  border: 1px solid rgba(255, 255, 255, 0.15);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
.template-accent {
  font-weight: 500;
}
</style>
